import { motion } from "framer-motion";

const quoteVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1 } },
};

const quoteBackgroundVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1 } },
};

const quoteContentVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.2 } },
};

const quoteContentVariants2 = {
  hidden: { opacity: 0, y: 100 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.2 } },
};

const Quote = () => {
  return (
    <motion.div
      variants={quoteVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="quote"
    >
      <motion.div
        variants={quoteBackgroundVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="quote-background"
      ></motion.div>
      <motion.div
        variants={quoteContentVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="quote-content"
      >
        <motion.h5
          variants={quoteContentVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          “For every minute spent organizing, an hour is earned.”
        </motion.h5>
        <motion.p
          variants={quoteContentVariants2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          - Benjamin Franklin
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default Quote;
